import React, { useEffect } from 'react';
import { useContext } from 'react';
import AuthContext from '../../store/auth-context';
import Navbar from '../Navbar';
import AdminWrapper from './AdminWrapper';

const ScreenWrapper = ({ children }) => {
  const context = useContext(AuthContext);

  useEffect(() => {
    context.pathnameHandler(window.location.pathname);
  });

  return (
    <main className='custom-scroll align-items-center flex-1 flex-wrap gap-4'>
      <div className='main-screen'>
        <div className='main-screen__boxes'>
          <div className='main-screen__boxes-left'></div>
          <div className='main-screen__boxes-right'></div>
          <div className='main-screen__boxes-tleft'></div>
          <div className='main-screen__boxes-tright'></div>
          <div className='main-screen__boxes-bleft'></div>
          <div className='main-screen__boxes-bright'></div>
        </div>
        <div
          className={`main-screen-container ${
            context.loading
              ? ' d-flex align-items-center justify-content-center '
              : ''
          }`}
        >
          {/* {  context.loading ? (
            <div className='spinner-box'>
              <div className='three-quarter-spinner'></div>
            </div>
          ) : (
            children
          )} */}
          {context.pathname === '/' ? (
            children
          ) : context.loading ? (
            <div className='spinner-box'>
              <div className='three-quarter-spinner'></div>
            </div>
          ) : (
            children
          )}
        </div>
      </div>

      <Navbar />
    </main>
  );
};

const Screen = ({ children }) => {
  const context = useContext(AuthContext);

  useEffect(() => {
    context.pathnameHandler(window.location.pathname);
  });

  useEffect(() => {}, [context.loading, context.pathname]);

  return (
    <>
      {context.pathname !== '/login' && context.pathname !== '/admin' ? (
        <ScreenWrapper>{children}</ScreenWrapper>
      ) : (
        <AdminWrapper>{children}</AdminWrapper>
      )}
    </>
  );
};

export default Screen;
